import { RepositoryFactory } from '../../RepositoryFactory';
import Vue from 'vue';
const items = new RepositoryFactory('items');
import api from '@/api.js';

export default {
  namespaced: true,
  state: {
    // Single item
    item: {
      id: null,
      name: '',
      type: '',
      icon_name: '',
      icon_url: '',
      createdAt: '',
      updatedAt: '',
    },
    items: [],

    // Pagination Params
    currentPage: 1,
    total: 0,
    totalPages: 0,
    itemCount: 0,

    // Actions States
    loading: false,
    error: false,
    createError: '',
  },
  getters: {
    getItem(state) {
      return state.item;
    },
    getItems(state) {
      for (const iterator of state.items) {
        const date = new Date(iterator.createdAt);
        iterator.createdAt = date.toLocaleDateString('pt-BR');

        const updatedAt = new Date(iterator.updatedAt);
        iterator.updatedAt = updatedAt.toLocaleDateString('pt-BR');
      }

      return state.items.map(s => ({
        id: s.id,
        name: s.name,
        type: s.type,
        createdAt: s.createdAt,
        updatedAt: s.updatedAt,
      }));
    },
    getItemsTableData(state) {
      return {
        error: state.error,
        loading: state.loading,
        currentPage: state.currentPage,
        totalPages: state.totalPages,
        itemCount: state.itemCount,
        total: state.total,
      };
    },
    getError(state) {
      return state.error;
    },
    getCreateError(state) {
      if (state.createError) {
        return state.createError.message;
      } else {
        return '';
      }
    },
  },
  mutations: {
    SET_ITEM(state, data) {
      state.item = data;
    },
    SET_ITEMS(state, data) {
      state.items = data.items;
      state.total = data.totalOfItems;
      // state.itemCount = data.itemCount;
      state.totalPages = data.pageCount;
    },
    SET_ALL_ITEMS(state, data) {
      state.items = data;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
  },
  actions: {
    setPage: async ({ commit, dispatch }, page) => {
      commit('SET_PAGE', page);
      dispatch('getItems');
    },
    resetPagination: async ({ commit, dispatch }) => {
      commit('SET_PAGE', 1);
      dispatch('getItems');
    },
    update: async ({ dispatch }, payload) => {
      try {
        await items.update(payload.id, payload.params);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Item atualizado com sucesso!',
        });
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
      dispatch('getItems');
    },
    create: async ({ commit, dispatch }, payload) => {
      try {
        const res = await items.create(payload);
        Vue.prototype.$notify({
          type: 'success',
          message: 'Item criado com sucesso!',
        });
        dispatch('getItems');
        return res.data.id;
      } catch (error) {
        Vue.prototype.$notify({
          type: 'danger',
          message: error.response.data.message,
        });
      }
    },
    getItemById: async ({ commit }, id) => {
      try {
        const { data } = await items.getById(id);
        commit('SET_ITEM', data);
      } catch (error) {}
    },
    getItemsByBranchId: async ({ state, commit }, id) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await api.get(`/items/branch/${id}`);
        const response = {
          items: data,
        };
        commit('SET_ITEMS', response);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getItems: async ({ state, commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await items.get(state.currentPage);
        commit('SET_ITEMS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
    getItemsNoLimit: async ({ commit }) => {
      commit('SET_ERROR', null);
      commit('SET_LOADING', true);
      try {
        const { data } = await items.get();
        commit('SET_ALL_ITEMS', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
      commit('SET_LOADING', false);
    },
  },
};
